import { Modal } from 'antd';
import ListModal from './SearchList';

interface Props {
  search: boolean;
  onClose: () => void;
  type: string;
  handleSelect: (name: string, id: number) => void;
}

function InvoiceDocReferencedSearchModal({
  search,
  onClose,
  handleSelect,
  type,
}: Props) {
  return (
    <Modal open={search} onCancel={onClose} title={type} width={800}>
      <ListModal handleSelect={handleSelect} type={type} />
    </Modal>
  );
}

export default InvoiceDocReferencedSearchModal;
